'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoRecords = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NoRecords, _Component);

  function NoRecords() {
    (0, _classCallCheck3.default)(this, NoRecords);
    return (0, _possibleConstructorReturn3.default)(this, (NoRecords.__proto__ || (0, _getPrototypeOf2.default)(NoRecords)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoRecords, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          message = _props.message,
          className = _props.className;

      return _react2.default.createElement(
        'div',
        { className: className },
        message || t('No record found.')
      );
    }
  }]);
  return NoRecords;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  message: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = NoRecords;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/NoRecords/NoRecords.js
// module id = 2035
// module chunks = 1